import React from 'react';
import { ArrowUpRightIcon, MicIcon, MessagesSquareIcon, ClipboardListIcon, UsersIcon } from 'lucide-react';
export const NexioSection = () => {
  const features = [{
    icon: <MicIcon size={22} data-id="element-221" />,
    title: 'Call for Speakers',
    description: 'Collect, review, and approve speaker submissions through a single streamlined workflow.'
  }, {
    icon: <MessagesSquareIcon size={22} data-id="element-222" />,
    title: 'Audience Q&A',
    description: 'Capture audience questions in real time — from passive attendees to panel participants in seconds.'
  }, {
    icon: <ClipboardListIcon size={22} data-id="element-223" />,
    title: 'Submission Management',
    description: 'Organize proposals, assign reviewers, and track approvals on a unified dashboard.'
  }, {
    icon: <UsersIcon size={22} data-id="element-224" />,
    title: 'Community Engagement',
    description: 'Turn attendees into active participants with tools designed to spark contribution.'
  }];
  return <section id="nexio" className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-225">
      <div className="container mx-auto px-6 relative z-10" data-id="element-226">
        <div className="mb-5" data-id="element-227">
          <span className="text-[#1B2A4A] font-medium inline-flex items-center gap-2 bg-[#f5f5f5] px-4 py-1.5 rounded-full shadow-sm" data-id="element-228">
            <div className="w-6 h-6 bg-[#B87333] rounded-sm" data-id="element-229"></div>
            Partner Platform
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center mb-12 md:mb-16" data-id="element-230">
          <div data-id="element-231">
            <h2 className="text-3xl md:text-5xl font-bold text-[#1B2A4A] mb-6 leading-tight" data-id="element-232">
              Powered by{' '}
              <span className="font-serif italic text-[#B87333]" data-id="element-233">
                Nexio App
              </span>
            </h2>
            <p className="text-lg md:text-xl text-[#1B2A4A]/80 leading-relaxed mb-5" data-id="element-234">
              We partner with Nexio App to run the full call-for-speakers
              process and keep your community engaged before, during, and after
              the event.
            </p>
            <p className="text-base md:text-lg text-[#1B2A4A]/70 leading-relaxed" data-id="element-235">
              From collecting speaker submissions and managing reviewer panels
              to capturing audience questions live — Nexio gives conference
              organizers one platform to turn passive attendees into active
              participants.
            </p>
          </div>

          <div className="relative" data-id="element-236">
            <div className="absolute -top-4 -right-4 w-20 h-20 md:w-28 md:h-28 bg-[#B87333]/30 rounded-bl-3xl z-0" data-id="element-237"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 md:w-24 md:h-24 bg-[#1B2A4A]/10 rounded-tr-3xl z-0" data-id="element-238"></div>
            <div className="relative z-10 rounded-lg overflow-hidden shadow-xl border border-gray-100 bg-white" data-id="element-239">
              <img src="https://cdn.magicpatterns.com/uploads/9copdBnrdj2b4BTgj86doy/Schermafbeelding_2026-05-29_082344.png" alt="Nexio App dashboard for managing speaker submissions and audience engagement" className="w-full h-auto object-cover" data-id="element-240" />
            </div>
          </div>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12 md:mb-16" data-id="element-241">
          {features.map((feature, index) => <div key={index} className="bg-[#f5f5f5] p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1 duration-300 h-full flex flex-col" data-id="element-242">
              <div className="bg-[#B87333]/20 text-[#B87333] p-3 rounded-full w-fit mb-4" data-id="element-243">
                {feature.icon}
              </div>
              <h3 className="text-lg font-bold text-[#1B2A4A] mb-2" data-id="element-244">
                {feature.title}
              </h3>
              <p className="text-[#1B2A4A]/70 leading-relaxed text-sm" data-id="element-245">
                {feature.description}
              </p>
            </div>)}
        </div>

        {/* CTA strip */}
        <div className="bg-[#1B2A4A] rounded-lg p-6 md:p-10 shadow-lg" data-id="element-246">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-247">
            <div className="flex-1" data-id="element-248">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-249">
                See Nexio in action
              </h3>
              <p className="text-white/80 leading-relaxed max-w-xl" data-id="element-250">
                Explore the platform we use to run conference programs end to
                end — from open calls to live audience Q&A.
              </p>
            </div>
            <a href="https://conference.nexioapp.cloud/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#B87333] hover:bg-[#B87333]/90 text-[#1B2A4A] px-6 py-3.5 md:px-8 md:py-4 rounded-md font-medium text-lg transition-all shadow-md w-full md:w-auto flex-shrink-0" data-id="element-251">
              Visit Nexio App <ArrowUpRightIcon size={20} data-id="element-252" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};